import { useRef, useState } from "react";
import { useNavigate } from "react-router";
import { api } from "server-api";

export default function Signin(){
  const [error, setError] = useState('');
  const usernameRef = useRef();
  const passwordRef = useRef();
  const navigate = useNavigate();


  const handleClick = ()=>{
    const username = usernameRef.current.value;
    const password = passwordRef.current.value;

    if(username.length===0 || password.length===0) return;

    const send = async()=>{
      try{
        const response = await api.post('/signin', {username, password});
        localStorage.setItem('token', response.config.accessToken);
        navigate('/');
      }catch(err){
        setError(err.message);
      }
    }
    send();
  };

  return (
    <div className="flex flex-col items-center justify-center w-screen h-[700px] bg-gray-100">
      <p className="my-3 text-3xl">관리자 로그인</p>
      <p className="">{error}</p>
      <table>
        <tbody>
          <tr className="h-9">
            <th className="w-20">아이디</th>
            <td><input ref={usernameRef}/></td>
          </tr>
          <tr className="h-9">
            <th>비밀번호</th>
            <td><input ref={passwordRef}/></td>
          </tr>
        </tbody>
      </table>
      <button onClick={()=>handleClick()} 
        className="px-4 py-2 mt-4 text-white bg-black rounded">로그인</button>
    </div>
  );
}